module.exports = __webpack_public_path__ + "img/smart-phone.9f65213e.png";